(function() {
  if (customElements.get('hero-video-slider')) {
    return;
  }

  class HeroVideoSlider extends HTMLElement {
    connectedCallback() {
      if (this.initialized) {
        return;
      }

      this.initialized = true;
      this.slides = Array.prototype.slice.call(this.querySelectorAll('[data-hero-video-slide]'));
      this.dots = Array.prototype.slice.call(this.querySelectorAll('[data-hero-video-dot]'));
      this.ctaButtons = Array.prototype.slice.call(this.querySelectorAll('.hero__link .btn'));
      this.pauseButton = this.querySelector('[data-hero-video-pause]');
      this.currentIndex = 0;
      this.speed = parseInt(this.dataset.speed, 10) || 5000;
      this.autoplayEnabled = this.dataset.autoplay === 'true';
      this.userPaused = false;
      this.interactionPaused = false;
      this.ctaHovered = false;
      this.ctaFocused = false;
      this.reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

      this.handleDotClick = this.handleDotClick.bind(this);
      this.handlePauseClick = this.handlePauseClick.bind(this);
      this.handleCtaMouseEnter = this.handleCtaMouseEnter.bind(this);
      this.handleCtaMouseLeave = this.handleCtaMouseLeave.bind(this);
      this.handleCtaFocus = this.handleCtaFocus.bind(this);
      this.handleCtaBlur = this.handleCtaBlur.bind(this);
      this.handleVisibilityChange = this.handleVisibilityChange.bind(this);
      this.handleResize = this.handleResize.bind(this);
      this.handleBlockSelect = this.handleBlockSelect.bind(this);
      this.handleBlockDeselect = this.handleBlockDeselect.bind(this);
      this.handlePointerDown = this.handlePointerDown.bind(this);
      this.handlePointerMove = this.handlePointerMove.bind(this);
      this.handlePointerUp = this.handlePointerUp.bind(this);
      this.handlePointerCancel = this.handlePointerCancel.bind(this);

      this.addEventListener('click', this.handleDotClick);
      this.addEventListener('shopify:block:select', this.handleBlockSelect);
      this.addEventListener('shopify:block:deselect', this.handleBlockDeselect);
      this.addEventListener('pointerdown', this.handlePointerDown);
      this.addEventListener('pointermove', this.handlePointerMove);
      this.addEventListener('pointerup', this.handlePointerUp);
      this.addEventListener('pointercancel', this.handlePointerCancel);
      document.addEventListener('visibilitychange', this.handleVisibilityChange);
      window.addEventListener('resize', this.handleResize);

      if (this.pauseButton) {
        this.pauseButton.addEventListener('click', this.handlePauseClick);
      }

      this.ctaButtons.forEach(function(button) {
        button.addEventListener('mouseenter', this.handleCtaMouseEnter);
        button.addEventListener('mouseleave', this.handleCtaMouseLeave);
        button.addEventListener('focus', this.handleCtaFocus);
        button.addEventListener('blur', this.handleCtaBlur);
      }.bind(this));

      this.setSlideState(0, false);
      this.classList.add('loaded');
      this.syncVideoPlayback();
      this.startTimer();
    }

    disconnectedCallback() {
      if (!this.initialized) {
        return;
      }

      this.stopTimer();
      window.clearTimeout(this.transitionTimer);
      window.clearTimeout(this.resizeTimer);
      this.removeEventListener('click', this.handleDotClick);
      this.removeEventListener('shopify:block:select', this.handleBlockSelect);
      this.removeEventListener('shopify:block:deselect', this.handleBlockDeselect);
      this.removeEventListener('pointerdown', this.handlePointerDown);
      this.removeEventListener('pointermove', this.handlePointerMove);
      this.removeEventListener('pointerup', this.handlePointerUp);
      this.removeEventListener('pointercancel', this.handlePointerCancel);
      document.removeEventListener('visibilitychange', this.handleVisibilityChange);
      window.removeEventListener('resize', this.handleResize);

      if (this.pauseButton) {
        this.pauseButton.removeEventListener('click', this.handlePauseClick);
      }

      this.ctaButtons.forEach(function(button) {
        button.removeEventListener('mouseenter', this.handleCtaMouseEnter);
        button.removeEventListener('mouseleave', this.handleCtaMouseLeave);
        button.removeEventListener('focus', this.handleCtaFocus);
        button.removeEventListener('blur', this.handleCtaBlur);
      }.bind(this));

      this.initialized = false;
    }

    handleDotClick(event) {
      var dot = event.target.closest('[data-hero-video-dot]');

      if (!dot || !this.contains(dot)) {
        return;
      }

      var nextIndex = parseInt(dot.dataset.index, 10);
      this.showSlide(nextIndex, nextIndex < this.currentIndex ? -1 : 1);
    }

    handlePauseClick() {
      this.userPaused = !this.userPaused;
      this.pauseButton.setAttribute('aria-pressed', this.userPaused ? 'true' : 'false');
      this.pauseButton.textContent = this.userPaused ? 'Play hero slideshow' : 'Pause hero slideshow';

      if (this.userPaused) {
        this.stopTimer();
      } else {
        this.startTimer();
      }
    }

    handleCtaMouseEnter() {
      this.ctaHovered = true;
      this.stopTimer();
    }

    handleCtaMouseLeave() {
      this.ctaHovered = false;
      this.startTimer();
    }

    handleCtaFocus() {
      this.ctaFocused = true;
      this.stopTimer();
    }

    handleCtaBlur() {
      this.ctaFocused = false;
      this.startTimer();
    }

    handleVisibilityChange() {
      if (document.hidden) {
        this.stopTimer();
      } else {
        this.startTimer();
        this.syncVideoPlayback();
      }
    }

    handleResize() {
      window.clearTimeout(this.resizeTimer);
      this.resizeTimer = window.setTimeout(this.syncVideoPlayback.bind(this), 150);
    }

    handleBlockSelect(event) {
      var slide = event.target.closest('[data-hero-video-slide]');

      if (!slide || !this.contains(slide)) {
        return;
      }

      this.interactionPaused = true;
      this.stopTimer();
      this.showSlide(parseInt(slide.dataset.index, 10));
    }

    handleBlockDeselect() {
      this.interactionPaused = false;
      this.startTimer();
    }

    handlePointerDown(event) {
      if (this.slides.length < 2 || (event.pointerType === 'mouse' && event.button !== 0)) {
        return;
      }

      if (event.target.closest('a, button, input, select, textarea')) {
        return;
      }

      if (event.pointerType === 'mouse') {
        event.preventDefault();
      }

      this.pointerId = event.pointerId;
      this.pointerStartX = event.clientX;
      this.pointerStartY = event.clientY;
      this.pointerLastX = event.clientX;
      this.pointerLastY = event.clientY;
      this.gesturePaused = true;
      this.stopTimer();

      if (this.setPointerCapture) {
        this.setPointerCapture(event.pointerId);
      }
    }

    handlePointerMove(event) {
      if (event.pointerId !== this.pointerId) {
        return;
      }

      this.pointerLastX = event.clientX;
      this.pointerLastY = event.clientY;

      var distanceX = this.pointerLastX - this.pointerStartX;
      var distanceY = this.pointerLastY - this.pointerStartY;

      if (Math.abs(distanceX) > 10 && Math.abs(distanceX) > Math.abs(distanceY)) {
        this.classList.add('is-swiping');
        event.preventDefault();
      }
    }

    handlePointerUp(event) {
      if (event.pointerId !== this.pointerId) {
        return;
      }

      this.pointerLastX = event.clientX;
      this.pointerLastY = event.clientY;
      this.finishSwipe(true);
    }

    handlePointerCancel(event) {
      if (event.pointerId === this.pointerId) {
        this.finishSwipe(false);
      }
    }

    finishSwipe(shouldNavigate) {
      var distanceX = this.pointerLastX - this.pointerStartX;
      var distanceY = this.pointerLastY - this.pointerStartY;
      var threshold = Math.min(80, Math.max(45, this.clientWidth * 0.05));
      var isHorizontalSwipe = Math.abs(distanceX) >= threshold && Math.abs(distanceX) > Math.abs(distanceY) * 1.2;

      if (this.releasePointerCapture && this.hasPointerCapture && this.hasPointerCapture(this.pointerId)) {
        this.releasePointerCapture(this.pointerId);
      }

      this.classList.remove('is-swiping');
      this.pointerId = null;
      this.gesturePaused = false;

      if (shouldNavigate && isHorizontalSwipe) {
        var direction = distanceX < 0 ? 1 : -1;
        this.showSlide(this.currentIndex + direction, direction);
      } else {
        this.startTimer();
      }
    }

    showSlide(nextIndex, direction) {
      if (this.slides.length < 2 || isNaN(nextIndex)) {
        return;
      }

      nextIndex = (nextIndex + this.slides.length) % this.slides.length;
      direction = direction === -1 ? -1 : 1;

      if (nextIndex === this.currentIndex) {
        this.startTimer();
        return;
      }

      var currentSlide = this.slides[this.currentIndex];
      var nextSlide = this.slides[nextIndex];

      window.clearTimeout(this.transitionTimer);
      this.slides.forEach(function(slide) {
        if (slide !== currentSlide) {
          slide.classList.remove('is-exiting');
          slide.classList.remove('is-exiting-right');
          slide.classList.remove('is-preparing-left');
          slide.classList.remove('is-preparing-right');
        }
      });

      var preparingClass = direction === -1 ? 'is-preparing-left' : 'is-preparing-right';
      var exitingClass = direction === -1 ? 'is-exiting-right' : 'is-exiting';

      currentSlide.classList.remove('is-exiting');
      currentSlide.classList.remove('is-exiting-right');
      nextSlide.classList.remove('is-exiting');
      nextSlide.classList.remove('is-exiting-right');
      nextSlide.classList.add(preparingClass);
      nextSlide.offsetWidth;

      currentSlide.classList.remove('is-active');
      currentSlide.classList.add(exitingClass);
      currentSlide.setAttribute('aria-hidden', 'true');
      currentSlide.setAttribute('inert', '');

      nextSlide.classList.remove(preparingClass);
      nextSlide.classList.add('is-active');
      nextSlide.setAttribute('aria-hidden', 'false');
      nextSlide.removeAttribute('inert');

      nextSlide.querySelectorAll('video').forEach(function(video) {
        try {
          video.currentTime = 0;
        } catch (error) {
          // The video will still begin normally if metadata is not ready yet.
        }
      });

      this.currentIndex = nextIndex;
      this.updateDots();
      this.syncVideoPlayback();

      this.transitionTimer = window.setTimeout(function() {
        currentSlide.classList.remove('is-exiting');
        currentSlide.classList.remove('is-exiting-right');
      }, this.reduceMotion ? 0 : 720);

      this.startTimer();
    }

    setSlideState(activeIndex, animate) {
      this.currentIndex = activeIndex;

      this.slides.forEach(function(slide, index) {
        var isActive = index === activeIndex;
        slide.classList.toggle('is-active', isActive);
        slide.classList.remove('is-exiting');
        slide.classList.remove('is-exiting-right');
        slide.classList.remove('is-preparing-left');
        slide.classList.remove('is-preparing-right');
        slide.setAttribute('aria-hidden', isActive ? 'false' : 'true');

        if (isActive) {
          slide.removeAttribute('inert');
        } else {
          slide.setAttribute('inert', '');
        }
      });

      this.updateDots();
    }

    updateDots() {
      this.dots.forEach(function(dot, index) {
        dot.setAttribute('aria-current', index === this.currentIndex ? 'true' : 'false');
      }.bind(this));
    }

    syncVideoPlayback() {
      var activeSlide = this.slides[this.currentIndex];

      this.slides.forEach(function(slide) {
        var videos = slide.querySelectorAll('video');

        videos.forEach(function(video) {
          var shouldPlay = slide === activeSlide && video.getClientRects().length > 0 && !document.hidden;

          if (shouldPlay) {
            var playPromise = video.play();
            if (playPromise !== undefined) {
              playPromise.catch(function() {});
            }
          } else {
            video.pause();
          }
        });
      });
    }

    startTimer() {
      this.stopTimer();

      if (!this.autoplayEnabled || this.reduceMotion || this.userPaused || this.interactionPaused || this.ctaHovered || this.ctaFocused || this.gesturePaused || document.hidden || this.slides.length < 2) {
        return;
      }

      this.timer = window.setTimeout(function() {
        this.showSlide(this.currentIndex + 1);
      }.bind(this), this.speed);
    }

    stopTimer() {
      window.clearTimeout(this.timer);
      this.timer = null;
    }
  }

  customElements.define('hero-video-slider', HeroVideoSlider);
})();
